export const Translations_CN = {
	footer: {
		join: "现在加入这个讨论。无需应用程序或登录。",
		climate: "积极气候讨论。",
		tree: "已种好一棵。",
		start: "免费开始视频讨论。",
	},
};
